export interface NativeSource {
  id: string;
  name: string;
  jp: string;
  stat: string;
  statLabel: string;
  role: string;
  description: string;
  maintainer: string;
  license: string;
  licenseUrl: string;
  sourceUrl: string;
  tone: 'accent' | 'accent-2' | 'accent-3' | 'info' | 'success';
}

export const nativeSources: NativeSource[] = [
  {
    id: 'jmdict',
    name: 'JMdict',
    jp: '辞書',
    stat: '35,759',
    statLabel: 'entries',
    role: 'Japanese–English dictionary',
    description:
      'The reference Japanese-to-English dictionary used by Jisho, Yomichan and most serious Japanese tools. Every definition, reading and part-of-speech tag in NihonMaster is sourced from here.',
    maintainer: 'Electronic Dictionary Research and Development Group',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
    sourceUrl: 'https://www.edrdg.org/jmdict/j_jmdict.html',
    tone: 'accent',
  },
  {
    id: 'kanjidic',
    name: 'KANJIDIC2',
    jp: '漢字',
    stat: '13,108',
    statLabel: 'kanji',
    role: 'Kanji readings & meanings',
    description:
      'Every on/kun reading, meaning, radical, stroke count and JLPT level for every kanji used in modern Japanese — curated by the same academic group that maintains JMdict.',
    maintainer: 'Electronic Dictionary Research and Development Group',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
    sourceUrl: 'https://www.edrdg.org/wiki/index.php/KANJIDIC_Project',
    tone: 'accent-3',
  },
  {
    id: 'tatoeba',
    name: 'Tatoeba',
    jp: '例文',
    stat: '7,500+',
    statLabel: 'example sentences',
    role: 'Native-written example sentences',
    description:
      'Example sentences in practice modes and mock tests are sourced from the Tatoeba Project — a collaborative corpus of sentences written and reviewed by native speakers, not generated by AI.',
    maintainer: 'Tatoeba Project contributors',
    license: 'CC BY 2.0 FR',
    licenseUrl: 'https://creativecommons.org/licenses/by/2.0/fr/deed.en',
    sourceUrl: 'https://tatoeba.org',
    tone: 'accent-2',
  },
  {
    id: 'furigana',
    name: 'JmdictFurigana',
    jp: 'ふりがな',
    stat: '42,251',
    statLabel: 'alignments',
    role: 'Accurate furigana alignment',
    description:
      'The ruby-text mapping that lets us place hiragana precisely above the right kanji — so readings line up the way a Japanese textbook would print them.',
    maintainer: 'Doublevil',
    license: 'CC0 1.0',
    licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
    sourceUrl: 'https://github.com/Doublevil/JmdictFurigana',
    tone: 'info',
  },
  {
    id: 'voicevox',
    name: 'VOICEVOX',
    jp: '音声',
    stat: 'Japanese',
    statLabel: 'trained TTS',
    role: 'Pronunciation audio (TTS)',
    description:
      'Every vocabulary item and example sentence is read by VOICEVOX — a text-to-speech engine trained on Japanese voice actors. It is AI-generated audio, not recordings of native speakers, but pronunciation and pitch accent are far closer to natural Japanese than English-trained TTS engines.',
    maintainer: 'VOICEVOX / Hiroshiba et al.',
    license: 'Free with attribution',
    licenseUrl: 'https://voicevox.hiroshiba.jp/term/',
    sourceUrl: 'https://voicevox.hiroshiba.jp/',
    tone: 'success',
  },
];
